import * as React from 'react';
import {useEffect, useState} from "react";
import {
    APP_ACTION_ITEMS,
    AUTH_USER_EMAIL_KEY
} from "../../types";
import {useHistory, useLocation} from "react-router-dom";
import {currentSession, logout, signIn} from "../../Auth";

const Login: React.FunctionComponent = () => {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const history = useHistory();
    const location = useLocation();
    const fullPath = location.pathname;

    const [doActionItemRedirect, setDoActionItemRedirect] = useState(false);


    useEffect(() => {
        if (doActionItemRedirect) {
            history.push({
                pathname: APP_ACTION_ITEMS
            });
        }
    }, [doActionItemRedirect, history]);

    useEffect(() => {
        currentSession().then(s => {
            setDoActionItemRedirect(true);
        }).catch(e => {
            console.log(e)
        });
    }, [fullPath, history]);


    const onSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        setLoading(true);
        setMessage("");
        logout();
        signIn(username, password)
            .then(value => {
                localStorage.setItem(AUTH_USER_EMAIL_KEY, username);
                setDoActionItemRedirect(true);
            }).catch((ex) => {
            setMessage("Login failed.  Invalid username or password.");
        }).finally(() => setLoading(false));
    };

    return (
        <>
            <div className={"container mt-3"}>
                <div className={"row justify-content-md-center mb-3"}>
                    <img alt={"logo"} src={"/assets/dist/img/promises12_logo.jpg"}/>
                </div>
                <div className={"row justify-content-md-center"}>
                    <h4>Please sign in</h4>
                </div>
                <form onSubmit={onSubmit}>
                    <div className={"row justify-content-md-center"}>
                        <div className={"col-md-3 mb-3"}>
                            <input type="text" className="form-control" id="username"
                                   placeholder={"username"} value={username} required={true}
                                   onChange={e => setUsername(e.target.value)}/>
                        </div>
                    </div>
                    <div className={"row justify-content-md-center"}>
                        <div className={"col-md-3 mb-3"}>
                            <input type="password" className="form-control" id="password"
                                   placeholder={"password"} required={true} value={password}
                                   onChange={e => setPassword(e.target.value)}/>
                        </div>
                    </div>

                    <div className={"row justify-content-md-center"}>
                        <div className={"col-md-3 mb-3"}>
                            <button disabled={loading} type="submit" className="btn btn-primary btn-block">Sign in
                            </button>
                        </div>
                    </div>

                    <div className={"row justify-content-md-center"}>
                        <div className={"col-md-3 mb-3"}>
                            <div hidden={(!message)} className="alert alert-danger" role="alert">
                                {message}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default Login;